import {MailOutlined, UserOutlined} from "@ant-design/icons";
import {Flex, Input} from "antd";
import React, {useCallback} from "react";
import {LoginViewStore} from "../view-store";
import {FullWidthButton} from "../ui/FullWidthButton";
import {useTranslation} from "react-i18next";
import {ContentWrapper} from "../ui/ContentWrapper";
import {CentredTitle} from "../ui/CentredTitle";
import {useStepsProps} from "../hooks/useStepsProps";
import styled from "@emotion/styled";

const ButtonCol = styled(Flex)`
  padding-top: 24px;
  flex-direction: column;
  gap: 12px;
`

export const ChooseLoginMethodStep = () => {
    const loginMethod = LoginViewStore.useState(s => s.loginMethod);
    const member = LoginViewStore.useState(s => s.member);
    const email = LoginViewStore.useState(s => s.email);
    const {t} = useTranslation(["login"]);
    const {next} = useStepsProps();
    const inputProps = {
        size: 'large',
        disabled: true,
        placeholder: loginMethod === 'member' ? t(`member`) : t(`email`),
        value: loginMethod === 'member' ? member : email,
        prefix: loginMethod === 'member' ? <UserOutlined/> : <MailOutlined/>
    }

    const createClick =  (magicLink = false) => useCallback(async () => {
        await LoginViewStore.update(s => {
            s.magicLink = magicLink
        })
        await next(magicLink);
    }, [next]);
    return (
        <ContentWrapper>
            <CentredTitle level={5}>{t('preferLogin')}</CentredTitle>
            <Input {...inputProps}/>
            <ButtonCol>
                <FullWidthButton onClick={createClick(false)} type="primary">{t('withPassword')}</FullWidthButton>
                <FullWidthButton onClick={createClick(true)} type="link">{t('withMagicLink')}</FullWidthButton>
            </ButtonCol>
        </ContentWrapper>
    )
};
